import * as React from 'react';

import {EmailPreviewModal} from '../../../email/timeline/email-preview-modal';

type State = {
    currentEmailId: string | null | undefined;
};

export class MarketingEmailPreviewListener extends React.PureComponent<Record<any, any>, State> {
    constructor() {
        // @ts-expect-error
        super();
        this.state = {
            currentEmailId: null,
        };
    }

    componentDidMount() {
        if (typeof Peep !== 'undefined' && Peep.events) {
            $(window).on(
                Peep.events.openMarketingEmailPreview,
                (_: React.SyntheticEvent<any>, id: string) => {
                    this.setState({currentEmailId: id});
                }
            );
        }
    }

    componentWillUnmount() {
        if (typeof Peep !== 'undefined' && Peep.events) {
            $(window).off(Peep.events.openMarketingEmailPreview);
        }
    }

    render() {
        if (this.state.currentEmailId) {
            return (
                <EmailPreviewModal
                    onClose={() => {
                        this.setState({currentEmailId: null});
                    }}
                    emailId={this.state.currentEmailId}
                />
            );
        }

        return null;
    }
}
